import { useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { cafeDetail } from "../../../../api/cafe";
import { Cafe } from "../../../../api/types";
import {
  getYoutubeLiveList,
  YoutubeLiveDto,
} from "../../../../api/youtube-live";
import { cafeTournament } from "../../../../api/pub-tournament";

export const usePubDetail = (id: number) => {
  const history = useHistory();
  const [data, setData] = useState<Cafe | null>(null);
  const [liveList, setLiveList] = useState<YoutubeLiveDto[]>([]);
  const [loading, setLoading] = useState(true);

  const getData = useCallback(() => {
    // 펍 정보
    setLoading(true);
    cafeDetail(id)
      .then((res) => {
        res.reviewData.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );

        return cafeTournament(id).then((tournamentResponse) => {
          res.pubTournamentList = tournamentResponse;
          setData(res);
          return res;
        });
      })
      .catch((e: any) => {
        enqueueSnackbar("펍 정보를 가져올 수 없습니다: " + e.message, {
          variant: "error",
        });
        throw e;
      });

    // 유튜브 라이브
    getYoutubeLiveList([id])
      .then((res) => {
        const pubLives = res[0].youtubeLiveList;
        setLiveList(pubLives);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 80);
      });
  }, [id, history]);

  useEffect(() => {
    if (id === -1) return;
    getData();
  }, [getData]);

  return {
    data,
    liveList,
    loading,
    setLoading,
    getData,
  };
};
